import { hookstate } from "@hookstate/core";

export const NotificationState = hookstate(null);
